import React, { Component, Fragment, useState, useEffect } from 'react'
import clsx from 'clsx'
import {
  withStyles,
  makeStyles,
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ExpansionPanelActions,
  Tab,
  Tabs,
  Box,
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider,
  Fade,
  Button,
  Grow,
  IconButton,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import CloseIcon from '@material-ui/icons/Close'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import TrendingDownIcon from '@material-ui/icons/TrendingDown'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import AddIcon from '@material-ui/icons/Add'
import DonutChart from '../charts/DonutChart'
import RadialChart from '../charts/RadialChart'

const useStyles = makeStyles(theme => ({
  accordion: {
    background: `linear-gradient(to right, #1f91c2, #1ba69f)`,
    border: '2px solid #283891',
    padding: '1em',
  },
  tabRoot: {
    flexGrow: 1,
    display: 'flex',
    height: 250,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tab: {
    width: '100%',
    marginTop: '-30px'
  },
  indicator: {
    backgroundColor: '#fff',
    opacity: 0.7,
  },
  alerts: {
    borderRadius: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    width: '90%',
    height: '75px',
    marginTop: '10px',
    overflowY: 'auto',
  },
  alertAvatar: {
    width: '35px',
    height: '35px',
  },
  alertMessage: {
    margin: '10px 10px 0px 10px',
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      margin: '2px 10px 0px 10px',
    },
  },
  bulletin: {
    height: 225,
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    border: '2px solid rgba(235, 192, 84, 0.8)',
    overflowY: 'auto',
    [theme.breakpoints.down('lg')] : {
    }
  },
  socialMedia: {
    display: 'flex',
    height: 225,
    width: 400,
    overflowY: 'auto',
    border: '2px solid rgba(38, 76, 154, 0.7)',
    [theme.breakpoints.down('lg')] : {
      width: 300,
    }
  },
  moreInfoButton: {
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: '7px',
    borderLeft: `4px solid ${theme.palette.divider}`
  },
  expandIcon: {
    '&:hover': {
      color: '#324d4c',
      backgroundColor: 'rgba(221, 245, 233, 0.5)'
    }
  }
}))

// function TabPanel(props) {
//   const { children, value, index, ...other } = props
//
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`vertical-tabpanel-${index}`}
//       aria-labelledby={`vertical-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box p={3}>
//           {children}
//         </Box>
//       )}
//     </div>
//   )
// }

// function a11yProps(index) {
//   return {
//     id: `vertical-tab-${index}`,
//     'aria-controls': `vertical-tabpanel-${index}`
//   }
// }

const CustomButton = withStyles({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 12,
    border: '0px',
    // backgroundColor: 'rgba(255, 255, 255, 0.4)',
    color: '#011689',
    height: '100%',
    '&:hover': {
      // backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backgroundColor: 'transparent',
      color: '#0072ff',
      border: '0px',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none'
    },
    '&:focus': {
      boxShadow: 'none',
    }
  }
})(Button)

export default function WelcomeBoard(props) {

  // constructor(props) {
  //   super(props)
  //   console.log(props.alerts)
  //   this.state = {
  //     tab: 0,
  //     expanded: true,
  //   }
  // }

  // handleTabChange = (e, newTab) => {
  //   this.setState({
  //     tab: newTab
  //   })
  // }
  //
  // handleExpand = (e) => {
  //   this.setState({
  //     expanded: !this.state.expanded
  //   })
  // }

  // render() {
  //   const { classes } = this.props
    return (
      <div>
        hello
      </div>
      // <ExpansionPanel
      //   className={classes.accordion}
      //   expanded={false}
      // >
      //   <ExpansionPanelSummary>
      //     <div style={{display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'space-between', alignItems: 'left'}}>
      //       <Typography variant="h5" style={{fontSize: '25px', fontWeight: 'bold', color: '#fff'}}>Hello {this.props.currentUser[0].fname + ' ' + this.props.currentUser[0].lname}!</Typography>
      //       <Typography variant="caption" style={{fontSize: '17px', color: '#fff'}}>Welcome to your SmartDash by LS Direct</Typography>
      //     </div>
      //   </ExpansionPanelSummary>
      // </ExpansionPanel>
    )

}
